import { type AbstractIntlMessages } from 'next-intl';
import deepmerge from 'deepmerge';
import { DEFAULT_LOCALE } from '../constants';
import { type Locale } from '../types';

export function resolveTranslations<T = Locale>(
  locale?: T,
  ...translationSources: Partial<Record<string, AbstractIntlMessages>>[]
): AbstractIntlMessages {
  const l = locale || DEFAULT_LOCALE;
  const resolvedTranslations = translationSources.map((source) => {
    const defaultLocale = source[DEFAULT_LOCALE] || {};
    const userLocale = source[l as keyof typeof source] || {};

    return deepmerge(defaultLocale, userLocale);
  });

  return Object.assign({}, ...resolvedTranslations);
}
